/**
 * Hand a built workbook to the browser.
 *
 * This is the only part of the export path that touches the DOM, which is why
 * it is three lines in its own file: `reports.ts` and `xlsxWrite.ts` stay pure
 * and covered by tests, and everything untestable is here where there is
 * nothing to get wrong.
 */

import { writeWorkbook, type WriteSheet } from './xlsxWrite'

const XLSX_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

/** Build the workbook and save it as `filename`. */
export function downloadWorkbook(sheets: WriteSheet[], filename: string): void {
  const bytes = writeWorkbook(sheets)
  // `slice()` detaches the view from any larger pool before it becomes a Blob.
  saveBlob(new Blob([bytes.slice().buffer], { type: XLSX_MIME }), filename)
}

function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  // Firefox will not follow a click on an element that is not in the document.
  document.body.appendChild(link)
  link.click()
  link.remove()
  // Revoking synchronously cancels the download in Safari; a turn of the event
  // loop is enough for every browser to have taken the bytes.
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
